module.exports = __webpack_public_path__ + "static/media/mac.f471f02a.jpg";